import { DataTable } from 'primereact/datatable';
import Heading from '../../../../components/Heading/Heading';
import styles from '../../css/User.module.css';
import { useState, useEffect } from 'react';
import {
	approveUserAction,
	generateUserDetails,
	generateUsers,
	removeUser,
} from '../../../../utils/common.utils';
import CONSTANTS from '../../../../constants';
import { Column } from 'primereact/column';
import {
	getMonthFormatDate,
	getTimestamp,
} from '../../../../utils/getDate.utils';
import Icon from '../../../../components/Icon/Icon';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import ViewUserData from '../List Users/ViewUserData';

const ApproveUsers = () => {
	const [users, setUsers] = useState([]);
	const [userDetails, setUserDetails] = useState({});

	useEffect(() => {
		generateUsers(setUsers);
	}, []);

	// console.log(users);

	const handleApproveUser = (rowData) => {
		// console.log('Approving...');
		approveUserAction(rowData.userId, setUsers);
	};

	const handleDeleteUser = (rowData) => {
		// console.log('Deleting...');
		removeUser(rowData.userId, setUsers);
	};

	const handleGetUserDetails = (rowData) => {
		generateUserDetails(rowData.userId, setUserDetails, users, setUsers);
	};

	const creationDateTemplate = (field) => {
		const convertedTimestamp = getTimestamp(field.creationDate);
		const date = getMonthFormatDate(convertedTimestamp?.split(' ')[0]);
		const time = convertedTimestamp?.split(' ')[1];
		const ampm = convertedTimestamp?.split(' ')[2];
		return <span>{`${date} ${time} ${ampm}`}</span>;
	};

	const actionBodyTemplate = (rowData) => {
		return (
			<div className={styles['actions__container']}>
				<Icon
					icon="check_circle"
					tooltip={`Approve this user action request (${rowData.action})`}
					className={`${styles['actions-icon']} ${styles['table-icon']} approve`}
					onClick={() => handleApproveUser(rowData)}
				/>
				<Tooltip target=".approve" position="top" className={styles.tooltip} />
				<Icon
					icon="delete"
					tooltip="Delete this user creation request"
					className={`${styles['actions-icon']} ${styles['table-icon']} delete`}
					onClick={() => handleDeleteUser(rowData)}
				/>
				<Tooltip target=".delete" position="top" className={styles.tooltip} />
				<Button
					className={styles['action-button']}
					onClick={() => handleGetUserDetails(rowData)}
				>
					View Details
				</Button>
				<Dialog
					header="User Details"
					visible={rowData.visible}
					onHide={() => {
						//Change one single object
						const updatedUserDetails = { ...userDetails, visible: false };
						setUserDetails(updatedUserDetails);
						//Change array of objects to maintain state
						const updatedUserList = users.map((userObj) =>
							userObj.userId === rowData.userId ? updatedUserDetails : userObj
						);
						setUsers(updatedUserList);
					}}
				>
					<ViewUserData userData={userDetails} />
				</Dialog>
			</div>
		);
	};

	return (
		<div className="main">
			{/* (FUTURE) Add deleting and editing user approval later as well and use new name for this heading */}
			<Heading>Approve User Actions</Heading>
			<div className={styles['user__container']}>
				<div className={styles['table__container']}>
					<DataTable
						value={users}
						paginator
						rows={20}
						rowsPerPageOptions={[5, 10, 15, 20, 30, 50]}
						emptyMessage="No users found."
						removableSort
					>
						{CONSTANTS.userColumns.map((col) => (
							<Column
								key={col.field}
								field={col.field}
								header={col.header}
								sortable
								className={styles['wrap-text']}
							/>
						))}
						<Column
							body={creationDateTemplate}
							field="creationDate"
							header="Creation Date"
							sortable
						></Column>
						<Column field="action" header="Action" sortable></Column>
						<Column
							body={actionBodyTemplate}
							field="actions"
							header="User Actions"
							className={styles['actions__container_alt']}
						></Column>
					</DataTable>
				</div>
			</div>
		</div>
	);
};

export default ApproveUsers;
